/* eslint-disable no-undef, no-unused-expressions */
/* Fix regenerator runtime to support CSP, see https://github.com/facebook/regenerator/issues/378#issuecomment-765141043 */
typeof globalThis !== 'undefined' &&
  (globalThis.regeneratorRuntime = undefined);
